import { useState } from "react";
import { useForm } from "antd/lib/form/Form";

const useStatefulForm = () => {
  const [form] = useForm();
  const [isSubmitting, setSubmitting] = useState<boolean>(false);
  return { form, isSubmitting, setSubmitting };
};

export default useStatefulForm;
